<template>
    <div class="first container">
        <div class="row">
            <div class="col-8">
                <div class="headline h2">
                    <span>Fächer und Jahrgänge</span>
                </div>
                <div v-for="(row, index) in rows" v-bind:key="index" class="row">

                    <div class="col-10 input-group">
                        <!--<input type="text" v-model="row.name" name="name" placeholder="Schulfach"
                               v-validate="'required'">-->
                        <select v-model="row.name" name="name" v-validate="'required'">
                            <option value="" disabled selected >Schulfach</option>
                            <option v-for="(subject, index) in sortedSubjects" v-bind:key="index" >{{ subject.name }}</option>
                        </select>
                    </div>
                    <div class="col-2 input-group">
                        <button @click="deleteRow(index)" v-if="index!=0" class="delete">×</button>
                    </div>
                    <!--<div class="col-12 invalid">
                        {{ errors.first('Fach' + index + '-Jahrgang') }}
                    </div>-->
                    <div class="col-12 input-group checkbox-group">
                        <label v-for="(year, yearindex) in years" class="checkbox" v-bind:key="yearindex" v-bind:class="{ 'invalid': errors.first('Fach' + index + '-Jahrgang') }">
                            <input type="checkbox" :name="'Fach'+index+'-Jahrgang'" :value="year.name"
                                   v-model="row.selectedYears"
                                   v-validate="'required|minLength:1'" data-vv-as="Jahrgangsauswahl"> <span>{{ year.name }}</span>
                        </label>
                    </div>
                </div>
                <div class=" add-button">
                    <button @click="addRow" class="button">Fach hinzufügen</button>
                </div>

            </div>

            <div class="col-4 icon-master">
                <i class="fa fa-graduation-cap"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'firstStep',
        components: {},

        data: function () {
            return {
                years: [
                    {
                        id: 1,
                        name: 'Jahrgang 1-4',
                    },
                    {
                        id: 2,
                        name: 'Jahrgang 5-10',
                    },
                    {
                        id: 3,
                        name: 'Jahrgang 11-13',
                    }
                ],
                rows: [],

                subjects: [],
            }
        },

        computed: {
            sortedSubjects: function() {
                function compare(a, b) {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                }

                let clonedSubjects = this.subjects
                return clonedSubjects.sort(compare);
            }
        },

        mounted: function () {
            this.addRow(); // Initial ein Fach hinzufügen
            //this.$refs.address.focus();

            this.getSubjects();
        },

        beforeRouteLeave(to, from, next) {
            // Tells VeeValidate to validate all the fields in the component's scope
            this.$validator.validateAll().then((result) => {
                if (result) {
                    next();
                    return;
                }
                if (!result) {
                    console.log(this);
                }
            });
        },

        methods: {
            addRow() {
                this.rows.push({
                    selectedYears: [],
                    name: '',
                })

            },
            deleteRow(index) {
                this.rows.splice(index, 1)
            },

            getSubjects: async function () {
                const subjects = await this.$parent.apiGet('Subject')
                this.subjects = subjects.list
            },

            nextPage() {
                console.log(this.rows)
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Success
                        this.$emit('openNextPage', this);
                        return;
                    }
                    if (!result) {
                        // Error
                        console.log(this);
                    }
                });
            }
        }
    }
</script>

<style>
    .col-2.input-group {
        position: relative;
    }

    .input-group {
        margin-bottom: 1rem;
        position: relative;
    }

    .delete {
        background: none;
        border: none;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: #B61500;
        font-weight: bold;
        cursor: pointer;
        outline: 0;
    }

    .add-button {
        text-align: right;
        margin-bottom: 1rem;
    }

    .general-data {
        margin-top: 2rem;
    }
</style>